var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMyAccount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12540",
    "data-name": "Group 12540",
    transform: "translate(-30 -128)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_867",
    "data-name": "Ellipse 867",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(30 128)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user_1_",
    "data-name": "user (1)",
    transform: "translate(11.858 133.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12325",
    "data-name": "Group 12325",
    transform: "translate(27.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12324",
    "data-name": "Group 12324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5578",
    "data-name": "Path 5578",
    d: "M115.128,0a4.337,4.337,0,1,0,4.337,4.337A4.349,4.349,0,0,0,115.128,0Z",
    transform: "translate(-110.791)",
    fill: "#ed8b00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12327",
    "data-name": "Group 12327",
    transform: "translate(24.165 8.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12326",
    "data-name": "Group 12326",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5579",
    "data-name": "Path 5579",
    d: "M39.087,251a4.044,4.044,0,0,0-.436-.8,5.391,5.391,0,0,0-3.731-2.349.8.8,0,0,0-.549.133,4.623,4.623,0,0,1-5.455,0,.711.711,0,0,0-.549-.133,5.352,5.352,0,0,0-3.731,2.349,4.662,4.662,0,0,0-.436.8.4.4,0,0,0,.019.36,7.556,7.556,0,0,0,.511.758,7.2,7.2,0,0,0,.871.985,11.357,11.357,0,0,0,.871.758,8.637,8.637,0,0,0,10.3,0,8.326,8.326,0,0,0,.871-.758,8.748,8.748,0,0,0,.871-.985,6.642,6.642,0,0,0,.511-.758A.323.323,0,0,0,39.087,251Z",
    transform: "translate(-24.165 -247.841)",
    fill: "#ed8b00"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyAccount);
export default __webpack_public_path__ + "static/media/icon_my_account.a327d7b2fdd6bd61d55a9ef73b5d56b4.svg";
export { ForwardRef as ReactComponent };